import React from 'react';
import FailedCircleIcon from '../../assets/FailedCircleIcon';
import SuccessCircleIcon from '../../assets/SuccessCircleIcon';

const RCAEntity = {
  SUCCESS: 'I',
  FAILED: 'Failed',
};

const RCAIcons = ({ entity = RCAEntity.FAILED, size = 20 }) => {
  const normalizedEntity = entity === 'I' ? RCAEntity.SUCCESS : RCAEntity.FAILED;

  if (normalizedEntity === RCAEntity.SUCCESS) {
    return <SuccessCircleIcon size={size} />;
  }

  return <FailedCircleIcon size={size} />;
};

export default RCAIcons;
